import {
  IDocumentSignedURLRepository,
  IDocumentSignedURLRepositoryResponse,
} from "@/core/repositories/document";
import { createLogger, ILogger } from "@/infrastructure/services/logger";

export class GetDocumentSignedURLUseCase {
  private readonly logger: ILogger = createLogger("GetDocumentSignedURLUseCase");

  constructor(private readonly documentSignedURLRepository: IDocumentSignedURLRepository) {}

  async execute(
    file_path: string,
    file_type: string,
    downloadable_file_name?: string
  ): Promise<IDocumentSignedURLRepositoryResponse> {
    this.logger.info("Creating signed URL", {
      file_path,
      file_type,
      downloadable_file_name,
    });
    return this.documentSignedURLRepository.getDocumentSignedURL(file_path, file_type, downloadable_file_name);
  }
}
